import { ListOfDepartmentResponse } from './Api/ListOfDepartment.response';

export class ListOfDepartmentEntity extends ListOfDepartmentResponse {
	public static tryCast(o: any) {
		return Object.assign(new ListOfDepartmentEntity(), o);
	}
}
